var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "main-card mt-2" }, [
      _c("div", { staticClass: "card-header" }, [
        _c("ul", { staticClass: "nav nav-tabs card-header-tabs nav-fill" }, [
          _c(
            "li",
            {
              staticClass: "nav-item hoverPointer",
              on: {
                click: function($event) {
                  _vm.tabIndex = 0
                }
              }
            },
            [
              _c("a", { staticClass: "nav-link", class: _vm.isActive(0) }, [
                _vm._v("General Information")
              ])
            ]
          )
        ])
      ]),
      _c("div", { staticClass: "card-body" }, [
        _vm.tabIndex == 0
          ? _c(
              "div",
              { attrs: { deck: "" } },
              [_c("GeneralInfoTab", { attrs: { value: _vm.value } })],
              1
            )
          : _vm._e()
      ]),
      _vm.hasAssociatedAccount(_vm.value)
        ? _c("div", { staticClass: "card-footer" }, [
            _c(
              "span",
              { attrs: { id: "impersonate-gen" + _vm.value.apparatusId } },
              [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-primary mt-2",
                    attrs: {
                      type: "button",
                      disabled: !_vm.hasAssociatedAccount(_vm.value),
                      "data-toggle": "tooltip",
                      title: _vm.hasAssociatedAccount(_vm.value)
                        ? ""
                        : "No Owner Account",
                      "data-test-hook": "go-to-dashboard-button-search-result"
                    },
                    on: {
                      click: function($event) {
                        return _vm.ImpersonateEmail()
                      }
                    }
                  },
                  [_vm._v(" Impersonate User ")]
                )
              ]
            )
          ])
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }